import { combineReducers } from "redux";
import customiseReducer from "./customise/customiseReducer";
import LoginReducer from "./Login/LoginReducer";
import FlexiQuoteReducer from "./FlexiQuote/FlexiQuoteReducer";
import OpportunityReducer from "./Opportunity/OpportunityReducer";
import CustomerReducer from "./Customer/CustomerReducer";
import SalesOrderReducer from "./SalesOrder/SalesOrderReducer";
import PurchaseOrderReducer from "./PurchaseOrder/PurchaseOrderReducer";
import InvoiceRequestReducer from "./InvoiceRequest/InvoiceRequestReducer";
import SettingsReducer from "./Settings/SettingsReducer";
import ApprovalReducer from "./Approval/ApprovalReducer";
import TaskReducer from "./Tasks/TasksReducer";
import TimeSheetReducer from "./TimeSheet/TimeSheetReducer";
import EmailReducer from "./Email/EmailReducer";
import ActivityReducer from "./ActivityList/ActivityReducer";
import EmployeeAdvanceReducer from "./EmployeeAdvance/EmployeeAdvanceReducer";
import CategoryReducer from "./CategoryList/CategoryReducer";
import ExpenseClaimReducer from "./ExpenseClaim/ExpenseClaimReducer";
import ExpeseSettingsReducer from "./ExpenseSettings/ExpeseSettingsReducer";
import ReportsReducer from "./Reports/ReportsReducer";
import AlertMasterReducer from "./Alert/AlertMasterReducer";
import KitReducer from "./Kit/KitReducer";
import SDCustomerReducer from "./APMS/Customers/CustomersReducer";
import SDProjectsReducer from "./APMS/Projects/ProjectsReducer";
import SDSubProjectsReducer from "./APMS/SubProjects/SubProjectsReducers";
import SDTicketsReducer from "./APMS/Tickets/TicketsReducer";
import SDLogWorkReducer from "./APMS/LogWork/LogWorkReducer";
import TripReducer from "./Trip/TripsReducer";
import PolicyReducer from "./Policies/PolicyReducer";
import supportDeskDashboardReducer from "./APMS/dashboard/dashboardReducer";
import LeadsReducer from "./Leads/LeadsReducer";
import EnquiryReducer from "./Enquiry/EnquiryReducer";
import ComplaintsReducer from "./CustomerComplaints/complaintsReducer";
import InvoiceReducer from "./Invoice/invoiceReducer";
import BPMasterReducer from "./BPMaster/BPMasterReducer";
import salesQuoteReducer from "./SalesQuote/SalesQuoteReducer";
import NotificationReducer from "./Notification/NotificationReducer";
import { Dashboard } from "powerbi-client";
import DashboardReducer from "./Dashboard/DashboardReducer";
import DashboardManagerReducer from "./DashboardManager/DashboardManagerReducer";
import DynamicReportReducer from "./DynamicDashboard/DynamicDashboardReducer";
import pageHeaderReducer from "./PageHeader/PageHeaderReducer";

const rootReducer = combineReducers({
  customise: customiseReducer,
  login: LoginReducer,
  flexiQuote: FlexiQuoteReducer,
  opportunity: OpportunityReducer,
  customer: CustomerReducer,
  settings: SettingsReducer,
  salesOrder: SalesOrderReducer,
  salesQuote: salesQuoteReducer,
  purchaseOrder: PurchaseOrderReducer,
  invoiceRequest: InvoiceRequestReducer,
  approval: ApprovalReducer,
  tasks: TaskReducer,
  TimeSheet: TimeSheetReducer,
  email: EmailReducer,
  Activity: ActivityReducer,
  EmployeeAdvance: EmployeeAdvanceReducer,
  Category: CategoryReducer,
  ExpenseClaim: ExpenseClaimReducer,
  expenseSettings: ExpeseSettingsReducer,
  Reports: ReportsReducer,
  Alert: AlertMasterReducer,
  Kit: KitReducer,
  SDCustomer: SDCustomerReducer,
  SDProjects: SDProjectsReducer,
  SDSubProjects: SDSubProjectsReducer,
  SDTickets: SDTicketsReducer,
  SDLogWork: SDLogWorkReducer,
  Trip: TripReducer,
  Policy: PolicyReducer,
  supportDeskDashboard: supportDeskDashboardReducer,
  Leads: LeadsReducer,
  Enquiry: EnquiryReducer,
  Complaints: ComplaintsReducer,
  Invoice: InvoiceReducer,
  BPMaster: BPMasterReducer,
  notification: NotificationReducer,
  Dashboard:DashboardReducer,
  DashboardManager:DashboardManagerReducer,
  DynamicReport:DynamicReportReducer,
  pageHeader:pageHeaderReducer
});

export default rootReducer;
